import { useHistory } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, Chip, IconButton, ListItem, Stack, Typography } from "@mui/material";

import { getPriorityBadge } from "../../../Insights/Preview/InsightBadges";
import { type Insight } from "../../../Insights/types";
import { InsightImpact } from "../InsightImpact";

export const InsightRow = ({ insight, hideDivider }: { insight: Insight; hideDivider: boolean }) => {
  const priorityBadge = getPriorityBadge(insight) ?? (
    <Chip label="Actionable" variant="status" size="small" color="primary" sx={{ ml: 1, mb: 0.3 }} />
  );

  const history = useHistory();

  const handleClick = () => {
    history.push(`./optimize/insights/${insight.providerId}/${insight.key}`);
  };

  return (
    <ListItem
      divider
      sx={{ py: 1, borderBottom: hideDivider ? "none" : "1px solid", borderColor: "divider", cursor: "pointer" }}
      onClick={handleClick}
    >
      <Stack direction="row" alignItems="center" width="100%" spacing={2}>
        <Box sx={{ minWidth: 0, width: "55%" }}>
          <Typography variant="body2" noWrap sx={{ textOverflow: "ellipsis", overflow: "hidden", display: "block" }}>
            {insight.title}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            noWrap
            sx={{ textOverflow: "ellipsis", overflow: "hidden", display: "block" }}
          >
            {insight.shortDescription}
          </Typography>
        </Box>
        <Box sx={{ width: "25%" }}>
          <Typography variant="subtitle2" color="text.primary" sx={{ textAlign: "right" }}>
            <InsightImpact insight={insight} />
          </Typography>
        </Box>
        <Box sx={{ width: "20%", textAlign: "right" }}>{priorityBadge}</Box>

        <IconButton size="small" data-cy="insights-item-next">
          <ChevronRightIcon fontSize="inherit" />
        </IconButton>
      </Stack>
    </ListItem>
  );
};
